export default __webpack_public_path__ + "static/media/ayush.2db86689.png";